import { cn } from '@/lib/utils'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cva } from 'class-variance-authority'
import { Check } from 'lucide-react'
import * as React from 'react'

const checkboxVariants = cva(
  'block relative peer shrink-0 border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
        custom:
          'border-border-default-neutral bg-surface-backgroundElevated data-[state=checked]:border-border-default-neutral',
      },
      size: {
        sm: 'h-3 w-3 [&>svg]:h-2 [&>svg]:w-2 rounded-xs',
        md: 'h-[14px] w-[14px] [&>svg]:h-[10px] [&>svg]:w-[10px] rounded-xs',
        default: 'h-4 w-4 [&>svg]:h-3 [&>svg]:w-3 rounded-xs',
        lg: 'h-5 w-5 [&>svg]:h-4 [&>svg]:w-4 rounded-md',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    variant?: 'default' | 'custom'
    size?: 'sm' | 'md' | 'default' | 'lg'
  }
>(({ className, variant, disabled, size, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    disabled={disabled}
    className={cn(checkboxVariants({ variant, size, className }))}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check
        className={cn('text-contents-accent stroke-[5px] ', {
          'text-contents-disabled': disabled,
          'h-3 w-3': size === 'default' || !size,
          'h-2 w-2': size === 'sm',
          'h-4 w-4': size === 'lg',
          'h-[10px] w-[10px]': size === 'md',
        })}
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox, checkboxVariants }
